import { Provider } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { BrowserRouter, Redirect, Switch } from 'react-router-dom'
import moment from 'moment'
import { ThemeProvider, CssBaseline } from '@material-ui/core'
import { MuiPickersUtilsProvider } from '@material-ui/pickers'
import MomentUtils from '@date-io/moment'
import 'moment/locale/pl'
import 'moment/locale/en-gb'
import 'moment/locale/es'
import 'moment/locale/de'
import 'moment/locale/fr'
import {
  Layout,
  PrivateRoute,
  Route,
  ScrollToTop,
  SEO,
  SnackbarProvider,
} from 'shared/components'
import { theme } from 'config'
import { getDefaultLang } from 'config/i18n'
import { routes } from 'modules'
import { paths as HomePaths } from 'modules/Home/strings'
import { store } from './App.state'
import 'config/awsconfig'
import './App.style.css'

moment.locale(getDefaultLang())

const App = () => {
  const { i18n } = useTranslation()

  return (
    <Provider store={store}>
      <MuiPickersUtilsProvider
        utils={MomentUtils}
        libInstance={moment}
        locale={i18n.language}
      >
        <ThemeProvider theme={theme}>
          <SEO />
          <CssBaseline />
          <SnackbarProvider>
            <BrowserRouter>
              <ScrollToTop />
              <Switch>
                {routes.map(
                  ({ component, disableLayout = false, ...route }) => {
                    if (route.public)
                      return (
                        <Route
                          exact
                          key={`publicRoute-${route.path}`}
                          {...route}
                          component={component as React.ComponentType<any>}
                        />
                      )
                    const Component = component as () => JSX.Element
                    return (
                      <PrivateRoute
                        key={`privateRoute-${route.path}`}
                        {...route}
                      >
                        {disableLayout ? (
                          <Component />
                        ) : (
                          <Layout>
                            <Component />
                          </Layout>
                        )}
                      </PrivateRoute>
                    )
                  }
                )}
                <Redirect to={HomePaths.home} />
              </Switch>
            </BrowserRouter>
          </SnackbarProvider>
        </ThemeProvider>
      </MuiPickersUtilsProvider>
    </Provider>
  )
}

export default App
